/* eslint-disable complexity */
// Copyright (c) 2016 Deere & Company

import Tab from '../../shared/state/tab';

export const getNavigationTabs = () => {

    const navigationTabs = [];

    navigationTabs.push(new Tab({
        label: 'Analysis',
        route: '/rga/recalled/returned-part?tab=analyst'
    }));

    navigationTabs.push(new Tab({
        label: 'Additional Data',
        route: '/rga/recalled/returned-part?tab=additional-data'
    }));

    navigationTabs.push(new Tab({
        label: 'Attachment',
        route: '/rga/recalled/returned-part?tab=attachment'
    }));

    navigationTabs.push(new Tab({
        label: 'Q&A',
        route: '/rga/recalled/returned-part?tab=q-and-a'
    }));

    return navigationTabs;

};



// WEBPACK FOOTER //
// ./src/rga/shared/returned-part-navigation-helper.js